












import { defineComponent } from '@vue/composition-api';
import { InformationCircleIcon } from '@vue-hero-icons/outline';
export default defineComponent({
    name: 'DescriptionListItem',
    components: { InformationCircleIcon },
    props: {
        title: {
            type: String,
            required: false,
        },
        tooltip: {
            type: String,
            required: false,
            default: '',
        },
        double: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
});
